const List = () => import(/* webpackChunkName: "eventManage" */'@/components/pages/serviceDesk/List');
const EventCallRecord = () => import(/* webpackChunkName: "eventManage" */'@/components/pages/eventManage/CallRecord');
const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');

export default [
  {
    path: '/service-desk',
    name: 'serviceDesk',
    meta: {
      isEvent: true,
      roles: ['WORK_ORDER_QUERY'],
      title: '服务台',
      icon: 'staging',
    },
    component: Layout,
    children: [
      {
        path: 'list',
        name: 'deskList',
        meta: {
          roles: ['WF_EVENT_CALL_RECORD_QUERY'],
          title: '工单综合管理',
          icon: 'event-manage',
          activeMenu: '/service-desk/list/',
          componentName: 'List',
          breadcrumb: [
            {
              name: '工单综合管理',
              path: '/service-desk/list'
            }
          ]
        },
        component: List
      },
      {
        path: 'event-call-record',
        name: 'eventCallRecord',
        meta: {
          roles: ['WF_EVENT_CALL_RECORD_QUERY'],
          title: '来电记录',
          icon: 'event-manage',
          activeMenu: '/service-desk/event-call-record/',
          componentName: 'EventCallRecord',
          breadcrumb: [
            {
              name: '来电记录',
              path: '/service-desk/event-call-record'
            }
          ]
        },
        component: EventCallRecord
      },
    ]
 }
]


// WEBPACK FOOTER //
// ./src/router/serviceDesk.js